
define('text!templates/widgets/dataGridCells/entityReferenceCell.html',[],function () { return '<span data-bind="text: name"></span>';});

